<template>
  <div>
    <div class="standart-page">
      <div class="row">
        <div class="col-12"><h3 class="title">PERİYODİK GÖREV</h3></div>
        <div class="col-3"></div>
        <div class="col-6 d-flex justify-content-center">
          <Can I="create" a="/periyodik-gorevler/PeriyodikGorevlerTanim">
            <button class="btn btn-block mr-2 mt-0 wsnw" :class="activeTab === 1 ? 'btn-secondary' : 'btn-outline-secondary'" @click="changeComponent(1, 'PGs')">Periyodik Görevler</button>
            <button class="btn btn-block mr-2 mt-0 wsnw" :class="activeTab === 2 ? 'btn-secondary' : 'btn-outline-secondary'" @click="changeComponent(2, 'PGsTanim')">Periyodik Görevler Tanım</button>
          </Can>
        </div>
        <div class="col-3"></div>
      </div>
      <component :is="$store.state.pg.currentTab" />
    </div>
  </div>
</template>
<script>
import {mapActions} from "vuex";
export default {
  components: { },  
  data() {
    return {
      activeTab: 0
    }
  },
  methods: {
    ...mapActions("pg", ["changeDetailTab"]),
    changeComponent(id, cmp) {
      this.activeTab = id;
      this.changeDetailTab(cmp);
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  created() {
    this.changeComponent(1, "PGs");
  },
  watch: {}
};
</script>